import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Contact (root landing)
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);

// Pilots
export const listPilots = () => api.get("/pilots").then((r) => r.data);
export const getPilot = (slug) => api.get(`/pilots/${slug}`).then((r) => r.data);
export const createPilot = (payload) => api.post("/pilots", payload).then((r) => r.data);
export const updatePilot = (slug, payload) => api.put(`/pilots/${slug}`, payload).then((r) => r.data);
export const deletePilot = (slug) => api.delete(`/pilots/${slug}`).then((r) => r.data);

// Leads
export const submitPilotLead = (slug, payload) =>
  api.post(`/pilots/${slug}/leads`, payload).then((r) => r.data);
export const finalizePilotLead = (slug, payload) =>
  api.post(`/pilots/${slug}/leads/finalize`, payload).then((r) => r.data);
export const listPilotLeads = (slug) =>
  api.get(`/pilots/${slug}/leads`).then((r) => r.data);
